<template>
    <div v-if="body_show">
        <div class="task-box task2" v-if="show_new_task">
            <div class="task-title">
                {{ title }}
            </div>
            <div v-for="(item, index) in dynamicData" :class="[item.type === 'select2' ? 'in-block' : '', 'task-box task2 task-plr-reset']">
                <!-- fill -->
                <div v-if="item.type === 'fill'" class="task_f">
                    <h3 class="label">{{ item.label }}</h3>
                    <div class="clearfix">
                        <div v-if="item.yield" v-for="(item2, i2) in item.list" class="task_ninput pull-left">
                            <span v-if="!item2.attr">{{item2.label}}</span>
                            <input v-if="item2.attr" v-model="item2.value" type="text" :class="[i2 > 1 ? ' task_n_3' : '', 'task_n task_n_2']" />
                            <span v-if="item2.attr">{{item2.label}}</span>
                        </div>
                    </div>
                </div>
                <!-- title -->
                <div v-if="item.type === 'title'" class="task_f">
                    <h3 class="label">{{ item.label }}<span v-if="item.config">{{item.config.subtitle.text}}</span></h3>
                </div>
                <!-- tip -->
                <div v-if="item.type === 'tips'" class="task_f">
                    <h3 class="label">{{item.label}}
                        <span v-for="item2 in item.list" @click="showTagModul(item2.tip, item2.lab, item2.val)" :class="item2.tip ? 'noun' : ''">{{item2.tip ? item2.lab : item2}}</span>
                    </h3>
                </div>
                <!-- select1 -->
                <div v-if="item.type === 'select1'" class="cell project4-task-row clearfix">
                    <div v-for="item2 in item.list" class="pull-left">
                        <van-cell-group v-if="item2.attr" class="grouping project3-task1 pull-left clearfix"  @close="pickerShowClick(false)">
                            <van-field v-model="item2.value" @click="showPicker(item2.select, item2)" readonly />
                            <label class="choose_lable"></label>
                        </van-cell-group>
                        <span v-if="item2.attr" class="pull-left">{{item2.label}}</span>
                        <span v-else class="pull-left">{{item2.label}}</span>
                    </div>
                </div>
                <!-- select2 -->
                <div v-if="item.type === 'select2'" class="cell project4-task-row clearfix">
                    <span class="pull-left">{{item.label}}</span>
                    <van-cell-group class="grouping project3-task1 mt-reset pull-left clearfix"  @close="pickerShowClick(false)">
                        <van-field v-model="item.value" @click="showPicker(item.select, item)" readonly />
                        <label class="choose_lable"></label>
                    </van-cell-group>
                </div>
                <!-- textarea -->
                <div v-if="item.type === 'textarea'" class="cell clearfix">
                    <div class="task_f mt-reset clearfix">
                        <h3 class="label task_pb10">{{item.label}}<span v-if="item.tips">{{item.tips}}</span></h3>
                        <div class="input-mt mt-reset">
                            <textarea v-model="item.value" @input="changeVal($event, item, item.config.length)" :placeholder="item.config.tips"></textarea>
                        </div>
                        <span class="float">{{item.value.length}}/{{item.config.length}}</span>
                    </div>
                </div>
            </div>
            <div class="submitBtn">
                <van-button @click="dynDataSub"  :class="verification() ? 'actice' : ''">提交</van-button>
            </div>
            <!-- 选择 -->
            <van-popup v-model="picker_show" position="bottom"  @close="pickerShowClick(false)">
                <van-picker show-toolbar :columns="selectList" @cancel="picker_show = false" @confirm="confirm" />
            </van-popup>
            <!-- 弹出标签 -->
            <van-popup class="explain" v-model="tagModul"  @close="pickerShowClick(false)">
                <div>
                    <h2>{{ tagModulData.title }}</h2>
                    <div class="pps" v-html="tagModulData.content"></div>
                </div>
            </van-popup>
        </div>
        <div class="task-box task2" v-else>
            <div class="task-title">
    			{{ title }}
    		</div>
             <h3 class="pj-task-h3">选择3个成就事件，打磨你的⼀句话<span class="bt" @click="alertModule1=true">个人标签</span>（先填写，然后参与⼩组讨论）</h3>
             <div class="task_f">
    			<h3 class="label">现在请你认真的填写你在朋友圈收到好友给你的风格标签<span>（最多填写5个风格标签）</span></h3>
    			<div class="input-mt">
    				<textarea  v-model="credential" placeholder="填写要求：建议填写5个标签，每个标签10字以内，并用“/”区隔"></textarea>
    			</div>
    			<span class="float">{{credential.length}}/52</span>
    		</div>
            <div class="task_f">
    			<h3 class="label">成就事件1</h3>
    			<div class="input-mt">
    				<textarea  v-model="describeone" placeholder="直接取项目三任务二第一页的成就事件详述内容"></textarea>
    			</div>
    			<span class="float">{{describeone.length}}/150</span>
    		</div>
            <div class="task_f">
                <h3 class="label">一句话个人标签</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="asenbrand_one" type="text" placeholder="根据以上成就事件打造个人标签" />
                    </div>
                </div>
                <span class="float">{{asenbrand_one.length}}/40</span>
            </div>
            <div class="task_f">
    			<h3 class="label">成就事件2</h3>
    			<div class="input-mt">
    				<textarea  v-model="describetwo" placeholder="直接取项目三任务二第一页的成就事件详述内容"></textarea>
    			</div>
    			<span class="float">{{describetwo.length}}/150</span>
    		</div>
            <div class="task_f">
                <h3 class="label">一句话个人标签</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="asenbrand_two" type="text" placeholder="根据以上成就事件打造个人标签" />
                    </div>
                </div>
                <span class="float">{{asenbrand_two.length}}/40</span>
            </div>
            <div class="task_f">
    			<h3 class="label">成就事件3</h3>
    			<div class="input-mt">
    				<textarea  v-model="describethree" placeholder="直接取项目三任务二第一页的成就事件详述内容"></textarea>
    			</div>
    			<span class="float">{{describethree.length}}/150</span>
    		</div>
            <div class="task_f">
                <h3 class="label">一句话个人标签</h3>
                <div class="input-box input-mt">
                    <div>
                        <input v-model="asenbrand_three" type="text" placeholder="根据以上成就事件打造个人标签" />
                    </div>
                </div>
                <span class="float">{{asenbrand_three.length}}/40</span>
            </div>
            <div class="submitBtn">
                <van-button v-if="validationHandle()" @click="submitHandle"  class="actice" >提交</van-button>
                <van-button v-else >提交</van-button>
            </div>
    		<van-popup class="explain" v-model="alertModule1"  @close="pickerShowClick(false)">
    			<div>
    				<h2>个人标签</h2>
    				<div class="pps">
    					指通过梳理，建立起来的一个有价值、有独特性，吸引更多的潜在市场机会的一句话。
    				</div>
    			</div>
    		</van-popup>
        </div>
		<van-popup :close-on-click-overlay="false" v-model="nextModule"  @close="pickerShowClick(false)">
			<div class="modules">
				<div class="head clearfix">
					<img @click="nextModule = false" class="close" src="@a/close.png" alt="" />
				</div>
				<div class="con-img">
					<img src="@a/pr1.png" alt="图片正在加载中..." />
				</div>
				<div class="con-text">
					任务就像消消乐，完成就好，继续加油！
				</div>
				<router-link class="next-btn" :to="{path: 'project4_task2_new', query: objArg}">去开启下一任务</router-link>
			</div>
		</van-popup>
    </div>
</template>

<script>
import { getStorage, setStorage, isMain } from "@/utils/tools"
import { get_selfstock_data, update_selfstock_data, index, subtable } from "@/api/course"
import { shareCon } from "@/utils/wxconfig"
export default {
    data(){
        return{
            body_show:false,
            title:'T1：创造个人标签',
            alertModule1:false,
            credential:'',
            describeone:'',
            asenbrand_one:'',
            describetwo:'',
            asenbrand_two:'',
            describethree:'',
            asenbrand_three:'',
            nextModule:false,
            objArg: {
                cid: "",
                pid: "",
                id: "",
                name: ""
            },
            //
            dynamicData: [],
            form_id: '',
            tagModul: false,
            picker_show: false,
            tagModulData: {
                title: "默认标题",
                content: "默认标签提示内容"
            },
            selectItem: null,
            backupList: {},
            selectList: []
        }
    },
    computed: {
        show_new_task(){
            let q = this.$route.query;
            if(!isMain()){
                return true
            }
            if(isMain() && (q.cid == 5 || q.cid >= 7)){
                return true
            }
            return false
        }
    },
    methods:{
        preventDefault: function(e) {
            e.preventDefault();
        },
        /*
        *@Description: vue中mini-ui或vant popup与picker结合在iphone手机穿透问题
        *@MethodAuthor:  Zhang Xiao Guang
        *@Date: 2019-11-28 12:18:35
        */
        pickerShowClick(newval) {
            let self = this;
            if (newval) {
            document.getElementsByTagName("body")[0].addEventListener('touchmove', self.preventDefault, {
                passive: false
            }); //阻止默认事件
            } else {

            document.getElementsByTagName("body")[0].removeEventListener('touchmove', self.preventDefault, {
                passive: false
            }); //打开默认事件
            }
        },
        changeVal(ev, item, maxLen){
            let tarLen = ev.target.value.length;
            if(tarLen > maxLen){
                item.value = item.value.substring(0, maxLen);
            }
        },
        verification(){
            for(let arg of this.dynamicData){
                if(arg.type === 'fill' || arg.type === 'select1'){
                    for(let arg2 of arg.list){
                        if(arg2.attr && !arg2.value){
                            return
                        }
                    }
                }else if(arg.type === 'select2' || arg.type === 'textarea'){
                    if(!arg.value){
                        return
                    }
                    if(arg.type === 'textarea' && arg.value.length > arg.config.length){
                        return
                    }
                }
            }
            return true
        },
        getDynData(){
            let newData = []
            for(let arg of this.dynamicData){
                if(arg.type === 'fill' || arg.type === 'select1'){
                    let conJson = {};
                    for(let item of arg.list){
                        if(item.attr){
                            conJson[item.attr] = item.value
                        }
                    }
                    newData.push({
                        'field_id': arg.id,
                        'content': JSON.stringify(conJson)
                    })
                }else if(arg.type === 'select2' || arg.type === 'textarea'){
                    newData.push({
                        'field_id': arg.id,
                        'content': arg.value
                    })
                }
            }
            return newData
        },
        dynDataSub(){
            let testResult = this.verification();
            if(!testResult){
                return
            }
            // loading
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            // 成立
            let getData = this.getDynData();
            // console.log(JSON.stringify(getData));
            let q = this.$route.query;
            subtable({
                cid: q.cid,
                type: "taskone",
                cpid: q.pid,
                cptid: q.id,
                form_id: this.form_id,
                field: JSON.stringify(getData)
            })
            .then((data) => {
                let q = this.$route.query;
                this.$toast.clear();
                this.nextModule = true;
                this.objArg.cid = q.cid;
                this.objArg.id = Number(q.id) + 1;
                this.objArg.pid = q.pid;
                this.objArg.name = encodeURIComponent(data.name);
            })
        },
        confirm(val){
            this.selectItem.value = val;
            this.pickerShowClick(true);
            this.picker_show = false;
        },
        showPicker(select, item){
            this.picker_show = true;
            this.selectItem = item;
            this.selectList = select;
        },
        showTagModul(bool, title, content){
            if(!bool){
                return
            }
            this.tagModul = true;
            this.tagModulData['title'] = title;
            this.tagModulData['content'] = content;
        },
        pullData(){
            let q = this.$route.query;
            if(this.show_new_task){
                // 新版本
                this.dynamicData = [];
                index({
                    cid: q.cid,
                    cpid: q.pid,
                    cptid: q.id
                })
                .then(data => {
                    this.title = data.title;
                    let isReset = !!data.userfield.length;

                    let userData = data.userfield;
                    let newJSON = {};
                    for(let arg of userData){
                        newJSON[arg.field_id] = arg.content;
                    }

                    // 没有编辑过
                    let list = data.field;
                    this.form_id = list[0].form_id;
                    // 取默认数据
                    for(let arg of list){
                        if(arg.type === 'fill'){
                            // 存key
                            let nk = {};
                            for(let [index, arg2] of arg.config.text.entries()){
                                if(arg2.attr){
                                    arg2.value = '';
                                    nk[arg2.attr] = index;
                                }
                                if(!isReset && arg2.attr){
                                    arg2.value = arg.config.variable[arg2.attr].content;
                                }
                            }

                            let nd = {
                                id: arg.id,
                                type: 'fill',
                                yield: true,
                                label: arg.label,
                                back: nk,
                                list: arg.config.text
                            }

                            if(isReset){
                                let sc = JSON.parse(newJSON[nd.id]);
                                for(let attr in nk){
                                    let index = nk[attr];
                                    let value = sc[attr];
                                    nd.list[index].value = value;
                                }
                            }
                            this.dynamicData.push(nd)
                        }else if(arg.type === 'title'){
                            this.dynamicData.push({
                                id: arg.id,
                                type: 'title',
                                yield: false,
                                config: arg.config,
                                label: arg.label
                            })
                        }else if(arg.type === 'tips'){
                            let j = arg.config.subtitle.difficult;
                            let t = arg.config.subtitle.text;
                            let key;
                            for(let attr in j){
                                key = attr;
                            }
                            let arr = t.split(key);
                            arr[2] = arr[1];
                            arr[1] = {
                                tip: true,
                                lab: key,
                                val: j[key].content.replace(/\n/ig, '<br/>')
                            }
                            this.dynamicData.push({
                                id: arg.id,
                                type: 'tips',
                                yield: true,
                                label: arg.label,
                                list: arr
                            })
                        }else if(arg.type === 'select'){
                            let text = arg.config.text;
                            let json = arg.config.variable;
                            // 多项
                            if(text){
                                let nk = {}
                                for(let [index, arg2] of text.entries()){
                                    if(arg2.attr){
                                        arg2.value = '';
                                        arg2.select = json[arg2.attr].content;
                                        nk[arg2.attr] = index;
                                    }
                                }
                                let nd = {
                                    id: arg.id,
                                    type: 'select1',
                                    yield: true,
                                    back: nk,
                                    list: text
                                }
                                if(isReset){
                                    let sc = JSON.parse(newJSON[nd.id]);
                                    for(let attr in nk){
                                        let index = nk[attr];
                                        let value = sc[attr];
                                        nd.list[index].value = value;
                                    }
                                }
                                this.dynamicData.push(nd)
                            }else{
                                let nd = {
                                    id: arg.id,
                                    type: 'select2',
                                    yield: false,
                                    value: '',
                                    label: arg.label,
                                    select: arg.config.content
                                }
                                if(isReset){
                                    nd.value = newJSON[nd.id]
                                }
                                this.dynamicData.push(nd)
                            }
                        }else if(arg.type === 'textarea'){
                            let nd = {
                                id: arg.id,
                                type: 'textarea',
                                yield: false,
                                label: arg.label,
                                tips: arg.config.subtitle ? arg.config.subtitle.text : false,
                                value: '',
                                config: {
                                    tips: arg.config.placeholder,
                                    length: arg.config.word
                                }
                            }
                            if(isReset){
                                nd.value = newJSON[nd.id]
                            }
                            this.dynamicData.push(nd)
                        }
                    }
                    //

                    this.body_show = true;
                    console.log(this.dynamicData);
                })
            }else{
                // 老版本
                get_selfstock_data({
                    cid: q.cid,
                    type:"taskone"
                })
                .then(data => {
                    this.body_show = true;
                    let d = data.data;
                    let path =this.$route.path;

                    this.credential = d.credential?d.credential:getStorage(path, 'credential') || '';
                    this.describeone = d.describeone?d.describeone:getStorage(path, 'describeone') || '';
                    this.asenbrand_one = d.asenbrand_one?d.asenbrand_one:getStorage(path, 'asenbrand_one') || '';
                    this.describetwo = d.describetwo?d.describetwo:getStorage(path, 'describetwo') || '';
                    this.asenbrand_two = d.asenbrand_two?d.asenbrand_two:getStorage(path, 'asenbrand_two') || '';
                    this.describethree = d.describethree?d.describethree:getStorage(path, 'describethree') || '';
                    this.asenbrand_three = d.asenbrand_three?d.asenbrand_three:getStorage(path, 'asenbrand_three') || '';

                });
            }
        },
        // 非空验证
        validationHandle(){
            let str_fields = [
                'credential',
                'describeone',
                'asenbrand_one',
                'describetwo',
                'asenbrand_two',
                'describethree',
                'asenbrand_three'
            ];
            // 循环判断数组内属性内容是为空
            for(let i = 0; i < str_fields.length; i++) {
                if(this.$Validator.isEmpty(this[str_fields[i]])){
                    return false;
                }
            }
            return true;
        },
        // 提交数据
        submitHandle(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            update_selfstock_data({
               cid:this.$route.query.cid,
                type:"taskone",
                cpid: this.$route.query.pid,
                cptid:this.$route.query.id,
                iscreate: 1,
                credential:this.credential,
                asenbrand_one:this.asenbrand_one,
                describeone:this.describeone,
                asenbrand_two:this.asenbrand_two,
                describetwo:this.describetwo,
                asenbrand_three:this.asenbrand_three,
                describethree:this.describethree,
            })
            .then(data => {
                this.$toast.clear();
                this.nextModule = true;
                this.objArg.cid = this.$route.query.cid;
                this.objArg.id = data.cptid;
                this.objArg.pid = this.$route.query.pid;
                this.objArg.name = encodeURIComponent(data.name);

            });
        },
        setTitle(){
            let title = this.$route.query.name;
            document.title = decodeURI(title);
        }
    },
    created(){
        this.pullData();
        this.setTitle();
        shareCon("course",this);
    },
    watch:{
        credential(newVal,oldVal){
            if(newVal.length > 52) {
              this.credential = newVal.slice(0, 52);
              this.$toast('最多只能输入'+52+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'credential', newVal);
            }
        },
        describeone(newVal,oldVal){
            if(newVal.length > 150) {
              this.describeone = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'describeone', newVal);
            }
        },
        asenbrand_one(newVal,oldVal){
            if(newVal.length > 40) {
              this.asenbrand_one = newVal.slice(0, 40);
              this.$toast('最多只能输入'+40+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'asenbrand_one', newVal);
            }
        },
        describetwo(newVal,oldVal){
            if(newVal.length > 150) {
              this.describetwo = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'describetwo', newVal);
            }
        },
        asenbrand_two(newVal,oldVal){
            if(newVal.length > 40) {
              this.asenbrand_two = newVal.slice(0, 40);
              this.$toast('最多只能输入'+40+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'asenbrand_two', newVal);
            }
        },
        describethree(newVal,oldVal){
            if(newVal.length > 150) {
              this.describethree = newVal.slice(0, 150);
              this.$toast('最多只能输入'+150+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'describethree', newVal);
            }
        },
        asenbrand_three(newVal,oldVal){
            if(newVal.length > 40) {
              this.asenbrand_three = newVal.slice(0, 40);
              this.$toast('最多只能输入'+40+'个字。/(ㄒoㄒ)/~~！');
		    }else{
                setStorage(this.$route.path, 'asenbrand_three', newVal);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    @import "@s/taskStyle.scss";
    .task-box.task2{
        padding-bottom: 0;
        h3{
            color: #EB5032;
            font-size: 32px;
            line-height: 42px;
        }
        h3.pj-task-h3{
            color: #333;
            margin-top: 40px;
            span{
                color: #EB5032;
            }
            span.bt{
                border-bottom: 1px solid #EB5032;
            }
        }
        .task_f{
            margin-top: 30px;
            .label{
                span{
                    font-size:24px;
                    color: #666;
                }
                label{
                    border-bottom: 1px solid #EB5032;
                }
                .noun{
                    color: #EB5032;
                }
            }
        }

        .explain{
            width: changeRem(13)+px;
            height: auto;
            border-radius: changeRem(0.16)+px;
            background: #fff;
            text-align: center;
            padding: changeRem(0.8)+px changeRem(1.2)+px;
            h2{
                text-align: justify;
                margin-top: 0;
                font-size: changeRem(0.64)+px;
                color: #EB5032;
                font-weight: normal;
                margin-bottom: changeRem(0.2)+px;
            }
            .pps{
                color: #333;
                font-size: changeRem(0.52)+px;
                line-height: changeRem(0.8)+px;
                text-align: justify;
            }
        }
    }
    //
    .task-plr-reset{
        padding-left: 0;
        padding-right: 0;
    }
    .task_ninput{
        .task_n_2{
            width: 60px;
        }
        .task_n_3{
            width: 112px;
        }
    }
    .mt-reset{
        margin-top: 0!important;
    }
    .in-block{
        display: inline-block;
    }
    .task_pb10{
        padding-bottom: 10px;
    }
    .project4-task-row{
        color: #666;
        word-wrap: break-word;
        word-break: normal;
        span{
            height: 69px;
            line-height: 69px;
            padding: 0 10px;
            display: block;
        }
    }
</style>
<style>
    .project3-task1 .van-cell .van-cell__value input{
        width: 2.5rem;
    }
</style>